var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"hideToggle":false}}),_c('Nav'),_c('Content',{class:{'lock-scroll': _vm.isMenuVisible}}),_c('Footer',{class:{'lock-scroll': _vm.isMenuVisible}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }